import { useState, useEffect } from 'react';

import { isTestModeOn } from '../utils/testMode';

import StrikeWithdrawalsModel from './StrikeWithdrawalsModel';

export function useWithdrawalsForClient(clientId, isAdmin = false) {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientId) {
      setLoading(false);
      setWithdrawals([]);
      return;
    }

    const onUpdateWithdrawals = (withdrawals) => {
      setWithdrawals(withdrawals);
      setLoading(false);
    };

    // Limit 52 = 1 year of withdrawals (52 weeks)
    const model = new StrikeWithdrawalsModel({
      viewModel: { updatedWithdrawalsDataSource: onUpdateWithdrawals },
      clientId,
      isTestMode: isTestModeOn(clientId),
      isAdmin,
      limit: 52
    });

    model.waitForWithdrawlsData();

    return function cleanup() {
      if (model) model.stop();
    };
  }, [clientId, isAdmin]);

  return [withdrawals, loading];
}

